import {Assignees} from './Assignees'
import {Development} from './Development'
import {Labels} from './Labels'
import {Reviewers} from './reviewers/Reviewers'
import {SidebarActions} from './SidebarActions'
import {ReviewersSection} from './reviewers/ReviewersSection'
import {SidebarSection} from './SidebarSection'
import {SidebarActivity} from './activity/SidebarActivity'
import {ActivitySection} from './activity/ActivitySection'
import {OverviewMergeStatus} from '@github-ui/mergebox/mini-merge'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {Suspense} from 'react'
import {TeamReviewSummary} from './reviewers/TeamReviewSummary'
import {Participants} from './overview-info/Participants'

export function OverviewInfoContent() {
  return (
    <ErrorBoundary boundaryName="OverviewInfoContent">
      <Suspense fallback={<div>Loading...</div>}>
        <OverviewInfo />
      </Suspense>
    </ErrorBoundary>
  )
}

function OverviewInfo() {
  return (
    <>
      <OverviewMergeStatus />

      <ActivitySection>
        <SidebarActivity />
      </ActivitySection>

      <SidebarSection title="Assignees">
        <Assignees />
      </SidebarSection>

      <ReviewersSection>
        <Reviewers />
      </ReviewersSection>

      <TeamReviewSummary />

      <SidebarSection title="Labels">
        <Labels />
      </SidebarSection>

      <SidebarSection title="Development">
        <Development />
      </SidebarSection>

      <Participants />

      <SidebarActions />
    </>
  )
}
